import { render } from "./PrivacySection.vue?vue&type=template&id=9b5cfa2a"
import script from "./PrivacySection.vue?vue&type=script&lang=js"
export * from "./PrivacySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__